/**
 * Inyeccion de dependencias para el cliente HTTP.
 * Evita ciclos: client.ts no importa stores ni entities; el cableado se
 * hace en app/providers.tsx al montar el provider raiz.
 */

type TokenProvider = () => string | null | undefined;
type RefreshHandler = () => Promise<void>;
type LogoutHandler = () => void;
type AuthEndpointChecker = (url: string | undefined) => boolean;
type ForbiddenHandler = () => void;

let tokenProvider: TokenProvider = () => null;
let refreshHandler: RefreshHandler = () => Promise.resolve();
let logoutHandler: LogoutHandler = () => undefined;
/**
 * Endpoints públicos (sin sesión) donde un 401 NO debe disparar el refresh ni
 * el logout/redirect: `auth/*` (login, refresh, reset/forgot password) y la
 * activación de cuenta (`users/activate`). Si no se excluyen, su 401 legítimo
 * (p. ej. `TOKEN_INVALID`) se confunde con sesión expirada y termina como
 * "Sin conexión" + redirect a /login.
 */
let authEndpointChecker: AuthEndpointChecker = (url) =>
  Boolean(url && /\/auth\/|\/users\/activate(?:[/?]|$)/.test(url));
let forbiddenHandler: ForbiddenHandler = () => undefined;

export function setTokenProvider(fn: TokenProvider): void {
  tokenProvider = fn;
}

export function setRefreshHandler(fn: RefreshHandler): void {
  refreshHandler = fn;
}

export function setLogoutHandler(fn: LogoutHandler): void {
  logoutHandler = fn;
}

export function setAuthEndpointChecker(fn: AuthEndpointChecker): void {
  authEndpointChecker = fn;
}

export function setForbiddenHandler(fn: ForbiddenHandler): void {
  forbiddenHandler = fn;
}

export function getTokenProvider(): TokenProvider {
  return tokenProvider;
}

export function getRefreshHandler(): RefreshHandler {
  return refreshHandler;
}

export function getLogoutHandler(): LogoutHandler {
  return logoutHandler;
}

export function getAuthEndpointChecker(): AuthEndpointChecker {
  return authEndpointChecker;
}

export function getForbiddenHandler(): ForbiddenHandler {
  return forbiddenHandler;
}
